/**
 * Extracts file extension/type from a filename for use with file viewers.
 * @param {string} fileName - The file name (e.g. "document.pdf")
 * @returns {string|null} - The file extension in lowercase, or null if not found
 */
export const getFileTypeFromName = (fileName) => {
  if (!fileName || typeof fileName !== 'string') return null;
  const parts = fileName.split('.');
  if (parts.length < 2) return null;
  return parts.pop().toLowerCase();
};
